import {
  withCompInfo,
  withCompPreviewInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  StripColumnsContainerDefinition,
  StripColumnsContainerCarmiData,
  StripColumnsContainerCss,
} from '../StripColumnsContainer.types';
import { withSiteDirection } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  StripColumnsContainerCarmiData,
  StripColumnsContainerDefinition,
  StripColumnsContainerCarmiData
>()([], (_, carmiData) => {
  return carmiData;
});

export const css = withCompPreviewInfo<
  StripColumnsContainerCss,
  StripColumnsContainerDefinition,
  StripColumnsContainerCss
>()(
  ['compProps', 'compData', 'isMobileView'],
  ({ compProps, compData, isMobileView }, carmiData) => {
    const { rowMargin, horizontalPaddingOnMobile } = compProps;
    const direction = compData?.direction ?? 'ltr';

    const mobileStyles = isMobileView
      ? {
          ...(rowMargin === 0 ? {} : { '--padding-y': `${rowMargin}px` }),
          ...(horizontalPaddingOnMobile && {
            '--padding-x': `${horizontalPaddingOnMobile}px`,
          }),
        }
      : {};

    return {
      ...carmiData,
      '--direction': withSiteDirection(direction),
      ...mobileStyles,
    };
  },
);

export const uiType = withCompInfo<any, any>()(['skin'], ({ skin }) => {
  if (skin === 'DesignedStrip') {
    return 'DesignedStrip';
  }
  return 'Default';
});

export default createComponentMapperModel({
  props,
  css,
  uiType,
});
